import request from '@hotmart/request'
import AuthService, { Bootstrap } from '@hotmart/cas-js'
import Cookies from 'js-cookie'
import { TAuth } from './auth.interfaces'
import {
  COOKIE_INTEGRATION_NAME,
  COOKIE_INTEGRATION_BW_CENTRAL,
  COOKIE_INTEGRATION_BACKOFFICE,
  DOMAINS,
  LOCALSTORAGE_TOKEN_NAME,
  EXPIRE_DATE_TOKEN_NAME,
  REQUEST_SECURITY
} from './auth.constants'

const clearCookies = () => {
  const domain = process.env.NODE_ENV === 'production' ? DOMAINS.production : DOMAINS.development

  Cookies.remove(COOKIE_INTEGRATION_BACKOFFICE, { domain })
  Cookies.remove(COOKIE_INTEGRATION_NAME, { domain })
  Cookies.remove(COOKIE_INTEGRATION_BW_CENTRAL, { domain })
  Cookies.remove(EXPIRE_DATE_TOKEN_NAME, { domain })
}

class AuthenticationService {
  private auth: TAuth
  private authService
  private surrogateService
  private bootstrap

  constructor() {
    const env = process.env.NODE_ENV === 'production' ? 'production' : 'development'

    this.authService = new AuthService({
      env,
      client_id: process.env.AUTH_CLIENT_ID
    })

    this.surrogateService = new AuthService({
      env,
      authority: `${process.env.SURROGATE_URL}/oidc`,
      client_id: process.env.SURROGATE_CLIENT_ID
    })

    this.bootstrap = new Bootstrap(this.authService)
  }

  login() {
    this.bootstrap.start()
  }

  logout(fromError = false, isAdmin = false, fromUser = false) {
    clearCookies()

    if (isAdmin) {
      this.bootstrap = new Bootstrap(this.surrogateService)
    }

    if (!fromError) {
      request(REQUEST_SECURITY.LOGOUT, { fromUser })
    }

    localStorage.removeItem(LOCALSTORAGE_TOKEN_NAME)

    this.bootstrap.logout()
  }

  subscribe(callback) {
    return this.bootstrap.subscribe({
      next: auth => {
        const hmVlcIntegration = encodeURIComponent(Cookies.get(COOKIE_INTEGRATION_NAME))

        callback(
          auth
            ? {
                ...auth,
                hmVlcIntegration
              }
            : null
        )
      }
    })
  }
}

const authService = new AuthenticationService()

export { authService, clearCookies }
